import React from 'react';
import {
  RULE_STATE,
  deriveRuleState,
  getInactiveReasonLabel,
  getRuleStateBadge,
} from '../../../constants/violationConstants';

/**
 * Состояние правила V2 (Part 4, раздел 3.4): ACTIVE / INACTIVE / DELETED.
 *
 * Булева `enabled` для этого не хватает — удалённое правило тоже приходит
 * выключенным. Причина неактивности показывается только у INACTIVE: у
 * tombstone'а она смысла не имеет, а при отсутствии кода строка не рисуется
 * вовсе, чтобы не дублировать сам бейдж.
 */
const RuleStatusBadge = ({ rule }) => {
  const state = deriveRuleState(rule);
  const badge = getRuleStateBadge(state);

  return (
    <span className="vio-rule-state">
      <span className={`vio-badge vio-badge--${badge.modifier}`}>{badge.label}</span>
      {state === RULE_STATE.INACTIVE && rule?.inactive_reason && (
        <span className="vio-rule-state-reason">
          {getInactiveReasonLabel(rule.inactive_reason)}
        </span>
      )}
    </span>
  );
};

export default RuleStatusBadge;
